module.exports = __webpack_public_path__ + "91c572758c577fa46d444a742ec35882.svg";